import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  categorySlug?: string;
}

export default function ComicCard({ id, title, author, cover, rating, status, categorySlug }: ComicCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[3/4] relative overflow-hidden">
          <img
            src={cover}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
            <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-1 rounded-md whitespace-nowrap">
              立即阅读
            </span>
          </div>
          {status === '连载中' && (
            <span className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap font-medium">
              {status}
            </span>
          )}
          {status === '已完结' && (
            <span className="absolute top-2 left-2 bg-secondary-600 text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap font-medium">
              {status}
            </span>
          )}
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="flex items-center gap-0.5 text-xs text-primary-500 font-medium">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </span>
        </div>
      </div>
    </Link>
  );
}